import React, { useState } from "react";
import "./OpportunitySearchSelect.css";

const OpportunitySearchSelect = ({
  opportunities = [],
  selectedIds = [],
  setSelectedIds = () => {},
  onApply = () => {}, // <-- Added
  loading,
  setIsDropdownOpen
}) => {
  const [searchQuery, setSearchQuery] = useState("");

  const filteredList = Array.isArray(opportunities)
    ? opportunities.filter((item) =>
        item.opportunity_name
          ?.toLowerCase()
          .includes(searchQuery?.toLowerCase())
      )
    : [];

  const toggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const isSelected = (id) => selectedIds.includes(id);

  return (
    <div className="opportunity-search-select">
      <input
        type="text"
        placeholder="Search by opportunity name"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="opportunity-search-input"
      />

     {!loading &&  <ul className="opportunity-list">
        {filteredList.map((item) => (
          <li key={item._id} className="opportunity-list-item">
            <label>
              <input
                type="checkbox"
                checked={isSelected(item._id)}
                onChange={() => toggleSelect(item._id)}
              />
              {item.opportunity_name}
            </label>
          </li>
        ))}
      </ul>}
      <div className="button-row">
        <button className="cancel-btn" onClick={() => {
          setIsDropdownOpen(false)
          setSelectedIds([])}}>
          Cancel
        </button>
        {loading ? (
            <div className="btn-spinner"></div>
          ) : (
            <button className="apply-btn" onClick={(e) =>{
              e.preventDefault();
               onApply(selectedIds)
               setIsDropdownOpen(false)
               }}>
              Apply
            </button>
          )}

      </div>
    </div>
  );
};

export default OpportunitySearchSelect;
